import { createReducer, on } from '@ngrx/store';

import { SsoState } from '../auth-state.model';
import { INITIAL_SSO_STATE } from '../auth-state.constants';
import { AuthSessionActions } from '../auth-session/auth-session.actions';
import { AuthSsoActions } from './auth-sso.actions';

export const authSsoReducer = createReducer(
  INITIAL_SSO_STATE,

  on(
    AuthSessionActions.loginSuccess,
    AuthSessionActions.hydrateSuccess,
    (state): SsoState => ({ ...state, isExchangingCode: false }),
  ),

  on(
    AuthSessionActions.logoutSuccess,
    AuthSessionActions.hydrateFailure,
    (): SsoState => INITIAL_SSO_STATE,
  ),

  on(
    AuthSsoActions.checkEmail,
    (state, { email }): SsoState => ({
      ...state,
      isCheckingEmail: true,
      email,
      error: null,
    }),
  ),

  on(
    AuthSsoActions.checkEmailSuccess,
    (state, { config }): SsoState => ({
      ...state,
      isCheckingEmail: false,
      oidcConfig: config,
    }),
  ),

  on(
    AuthSsoActions.checkEmailFailure,
    (state, { error }): SsoState => ({
      ...state,
      isCheckingEmail: false,
      error,
    }),
  ),

  on(
    AuthSsoActions.exchangeCode,
    (state): SsoState => ({
      ...state,
      isExchangingCode: true,
      error: null,
    }),
  ),

  on(
    AuthSsoActions.exchangeCodeFailure,
    (state, { error }): SsoState => ({
      ...state,
      isExchangingCode: false,
      error,
    }),
  ),
);
